import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Button,
  Container,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
  Divider,
  Grid,
  InputAdornment,
  Fab,
  Chip,
  Tabs,
  Tab,
  ToggleButtonGroup,
  ToggleButton,
  Card,
  CardContent,
  IconButton,
  Menu,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  CircularProgress,
  Alert,
  Badge,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemAvatar,
} from '@mui/material';
import AppTheme from '../../../../shared-theme/AppTheme';
import { CssBaseline } from '@mui/material';
import SideMenu from '../../../../components/SideMenu';
import Header from '../../../../components/Header';
import { 
  ArrowBack, 
  Person, 
  LocationOn, 
  Assignment, 
  TrendingUp, 
  History, 
  Edit, 
  Delete, 
  Add, 
  CheckCircle, 
  Cancel, 
  Schedule,
  MonetizationOn,
  People,
  Route,
  Assessment
} from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { StyledCellHeader } from '../../../../components/StyledCellHeader';
import { formatNumberWithCommas, formatCurrency } from '../../../../utils/generalFunctions';
import AlertMessageDialog from '../../../../components/Dialogs/alertMessageDialog';
import AsignarPrestamosDialog from './asignarprestamos';
import AsignarCobradorDialog from './asignarcobrador';
import CrearRutaDialog from './crearrutadialog';

// Helper function to capitalize strings
const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

function EstadoChip({ estado }) {
  let color = 'default';
  if (estado === 'activa') color = 'success';
  else if (estado === 'inactiva') color = 'error';
  return <Chip label={capitalize(estado)} color={color} textTransform="none" size='large'/>;
}

function ResultadoChip({ resultado }) {
  let color = 'default';
  let icon = null;
  
  switch (resultado) {
    case 'exitoso':
      color = 'success';
      icon = <CheckCircle />;
      break;
    case 'promesa_pago':
      color = 'warning';
      icon = <Schedule />;
      break;
    case 'no_contactado':
      color = 'error';
      icon = <Cancel />;
      break;
    case 'rechazado':
      color = 'error';
      icon = <Cancel />;
      break;
    default:
      color = 'default';
      icon = <Assignment />;
  }
  
  return (
    <Chip 
      label={capitalize(resultado.replace('_', ' '))} 
      color={color} 
      icon={icon}
      textTransform="none" 
      size='small'
    />
  );
}

export default function RutaDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState("Info");
  const [ruta, setRuta] = useState({});
  const [prestamos, setPrestamos] = useState([]);
  const [visitas, setVisitas] = useState([]);
  const [performance, setPerformance] = useState({});
  const [loading, setLoading] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState('');
  const [openAsignarPrestamos, setOpenAsignarPrestamos] = useState(false);
  const [openAsignarCobrador, setOpenAsignarCobrador] = useState(false);
  const [openEditRuta, setOpenEditRuta] = useState(false);

  useEffect(() => {
    if (id) {
      fetchRutaDetail();
      fetchRutaPrestamos();
      fetchRutaVisitas();
      fetchRutaPerformance();
    }
  }, [id]);

  const fetchRutaDetail = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/rutas/detalle/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setRuta(data);
      } else {
        setMessageAlert('Error al cargar los detalles de la ruta');
        setOpenAlert(true);
      }
    } catch (error) {
      console.error('Error fetching ruta details:', error);
      setMessageAlert('Error al cargar los detalles de la ruta');
      setOpenAlert(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchRutaPrestamos = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/rutas/${id}/prestamos`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setPrestamos(data);
      }
    } catch (error) {
      console.error('Error fetching ruta prestamos:', error);
    }
  };

  const fetchRutaVisitas = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/rutas/${id}/visitas`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setVisitas(data);
      }
    } catch (error) {
      console.error('Error fetching ruta visits:', error);
    }
  };

  const fetchRutaPerformance = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/rutas/${id}/performance`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setPerformance(data);
      }
    } catch (error) {
      console.error('Error fetching ruta performance:', error);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleRefresh = () => {
    fetchRutaDetail();
    fetchRutaPrestamos();
    fetchRutaVisitas();
    fetchRutaPerformance();
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <AlertMessageDialog 
        message={messageAlert} 
        title={''} 
        severity={"success"} 
        color={"success"} 
        open={openAlert} 
        handleClose={() => setOpenAlert(false)}
      />

      <AppTheme themeComponents={{}}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
          <SideMenu />
          <Box component="main" sx={{ flexGrow: 1, overflow: 'auto' }}>
            <Stack
              spacing={2}
              sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
              <Header parent={"Gestión Comercial"} child={"Cobros Móviles"} />
              <Container maxWidth={"xl"} sx={{ px: { xs: 2, md: 10 }, py: 5, display: "flex", justifyContent: "center", flexDirection: "column", backgroundColor: "transparent"}}>
                <Box dividers display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                  <Box display={"flex"} alignItems={"center"}>
                    <Button variant="outlined" startIcon={<ArrowBack/>} onClick={() => navigate(-1)}>
                      Atrás
                    </Button>
                    <Box display={"flex"} flexDirection={"column"} gap={2} ml={5}>
                      <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={2}>
                        <Typography variant="h4" fontWeight={700} textAlign={"left"}>
                          {ruta.nombre}
                        </Typography>
                        {ruta.estado && <EstadoChip estado={ruta.estado} />}
                      </Box>
                      <Typography variant="body1" color="text.secondary" textAlign={"left"} sx={{mt: -2}}>
                        {ruta.descripcion || 'Detalles de la ruta de cobro'}
                      </Typography>
                    </Box>
                  </Box>
                  <Box display={"flex"} alignItems={"center"} gap={2}>
                    <Button 
                      variant="outlined" 
                      color="primary" 
                      startIcon={<Assignment />} 
                      sx={{fontWeight: "bold"}}
                      onClick={() => setOpenAsignarPrestamos(true)}
                    >
                      Asignar Préstamos
                    </Button>
                    <Button 
                      variant="outlined" 
                      color="secondary" 
                      startIcon={<Person />} 
                      sx={{fontWeight: "bold"}}
                      onClick={() => setOpenAsignarCobrador(true)}
                    >
                      {ruta.cobrador_nombre ? 'Cambiar Cobrador' : 'Asignar Cobrador'}
                    </Button>
                    <Button 
                      variant="outlined" 
                      color="primary" 
                      startIcon={<Edit />} 
                      sx={{fontWeight: "bold"}}
                      onClick={() => setOpenEditRuta(true)}
                    >
                      Editar Ruta
                    </Button>
                  </Box>
                </Box>

                {/* Summary Cards */}
                <Grid container spacing={3} sx={{ mt: 2 }}>
                  <Grid item size={{ xs: 12, md: 3 }}>
                    <Card sx={{ p: 2, textAlign: 'center', background: 'linear-gradient(135deg, #55b4ac 0%, #4a9b94 100%)', color: 'white' }}>
                      <CardContent>
                        <Route sx={{ fontSize: 40, mb: 1 }} />
                        <Typography variant="h4" fontWeight="bold">
                          {ruta.zona_geografica || 'Sin zona'}
                        </Typography>
                        <Typography variant="body2">Zona Geográfica</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 3 }}>
                    <Card sx={{ p: 2, textAlign: 'center', background: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)', color: 'white' }}>
                      <CardContent>
                        <People sx={{ fontSize: 40, mb: 1 }} />
                        <Typography variant="h4" fontWeight="bold">
                          {ruta.cobrador_nombre || 'Sin asignar'}
                        </Typography>
                        <Typography variant="body2">Cobrador Asignado</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 3 }}>
                    <Card sx={{ p: 2, textAlign: 'center', background: 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)', color: 'white' }}>
                      <CardContent>
                        <MonetizationOn sx={{ fontSize: 40, mb: 1 }} />
                        <Typography variant="h4" fontWeight="bold">
                          {prestamos.length}
                        </Typography>
                        <Typography variant="body2">Préstamos Asignados</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 3 }}>
                    <Card sx={{ p: 2, textAlign: 'center', background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)', color: 'white' }}>
                      <CardContent>
                        <Assessment sx={{ fontSize: 40, mb: 1 }} />
                        <Typography variant="h4" fontWeight="bold">
                          {performance.tasa_exito || 0}%
                        </Typography>
                        <Typography variant="body2">Tasa de Éxito</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>

                <Grid container spacing={3} sx={{ mt: 2 }}>
                  <Grid item size={{ xs: 12 }}>
                    <Card variant="outlined" sx={{ borderRadius: 3, backgroundColor: "white" }}>
                      <CardContent>
                        <Box sx={{ 
                          display: 'flex', 
                          gap: 1, 
                          p: 1, 
                          backgroundColor: '#f5f5f5', 
                          borderRadius: 2,
                          border: '1px solid #e0e0e0'
                        }}>
                          {[
                            { value: "Info", label: "Información", icon: <Route /> },
                            { value: "Prestamos", label: "Préstamos", icon: <MonetizationOn /> },
                            { value: "Historial", label: "Historial", icon: <History /> },
                            { value: "Rendimiento", label: "Rendimiento", icon: <Assessment /> }
                          ].map((tab) => (
                            <Button
                              key={tab.value}
                              variant={tabValue === tab.value ? "contained" : "text"}
                              onClick={() => handleTabChange(null, tab.value)}
                              startIcon={tab.icon}
                              sx={{
                                borderRadius: 1.5,
                                textTransform: 'none',
                                fontWeight: tabValue === tab.value ? 600 : 500,
                                backgroundColor: tabValue === tab.value ? '#55b4ac' : 'transparent',
                                color: tabValue === tab.value ? 'white' : '#666',
                                '&:hover': {
                                  backgroundColor: tabValue === tab.value ? '#4a9b94' : '#e8f5f3',
                                  color: tabValue === tab.value ? 'white' : '#55b4ac'
                                },
                                minWidth: 'auto',
                                px: 2,
                                py: 1
                              }}
                            >
                              {tab.label}
                            </Button>
                          ))}
                        </Box>
                        
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{mt: 2}}>
                          <Typography variant="h6" fontWeight={700} textAlign={"left"}>
                            {tabValue}
                          </Typography>
                          {tabValue === "Prestamos" && (
                            <Button
                              variant="outlined"
                              startIcon={<Add />}
                              onClick={() => setOpenAsignarPrestamos(true)}
                              size="small"
                              sx={{ fontWeight: "bold" }}
                            >
                              Asignar Préstamos
                            </Button>
                          )}
                        </Box>

                        {tabValue === "Info" && (
                          <Grid container spacing={3} sx={{ mt: 2 }}>
                            <Grid item size={{ xs: 12, md: 6 }}>
                              <Card variant="outlined" sx={{ p: 2 }}>
                                <CardContent>
                                  <Typography variant="h6" fontWeight={600} mb={2}>
                                    Información General
                                  </Typography>
                                  <Box display="flex" flexDirection="column" gap={2}>
                                    <Box>
                                      <Typography variant="body2" color="text.secondary">Nombre</Typography>
                                      <Typography variant="body1" fontWeight={500}>{ruta.nombre}</Typography>
                                    </Box>
                                    <Box>
                                      <Typography variant="body2" color="text.secondary">Descripción</Typography>
                                      <Typography variant="body1" fontWeight={500}>{ruta.descripcion || 'Sin descripción'}</Typography>
                                    </Box>
                                    <Box>
                                      <Typography variant="body2" color="text.secondary">Zona Geográfica</Typography>
                                      <Typography variant="body1" fontWeight={500}>{ruta.zona_geografica || 'Sin zona asignada'}</Typography>
                                    </Box>
                                    <Box>
                                      <Typography variant="body2" color="text.secondary">Estado</Typography>
                                      <EstadoChip estado={ruta.estado} />
                                    </Box>
                                  </Box>
                                </CardContent>
                              </Card>
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                              <Card variant="outlined" sx={{ p: 2 }}>
                                <CardContent>
                                  <Typography variant="h6" fontWeight={600} mb={2}>
                                    Cobrador Asignado
                                  </Typography>
                                  {ruta.cobrador_nombre ? (
                                    <Box display="flex" alignItems="center" gap={2}>
                                      <Avatar sx={{ bgcolor: 'primary.main' }}>
                                        <Person />
                                      </Avatar>
                                      <Box>
                                        <Typography variant="body1" fontWeight={500}>
                                          {ruta.cobrador_nombre}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                          {ruta.cobrador_telefono}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  ) : (
                                    <Alert severity="info">
                                      No hay cobrador asignado a esta ruta
                                    </Alert>
                                  )}
                                </CardContent>
                              </Card>
                            </Grid>
                          </Grid>
                        )}

                        {tabValue === "Prestamos" && (
                          <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 'none', mt: 2 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <StyledCellHeader>Cliente</StyledCellHeader>
                                  <StyledCellHeader>Préstamo</StyledCellHeader>
                                  <StyledCellHeader>Monto</StyledCellHeader>
                                  <StyledCellHeader>Estado</StyledCellHeader>
                                  <StyledCellHeader>Última Visita</StyledCellHeader>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {prestamos.length === 0 ? (
                                  <TableRow>
                                    <TableCell size={{ xs: 12 }} align="center" sx={{ py: 4 }}>
                                      <Typography variant="h6" color="text.secondary">
                                        No hay préstamos asignados a esta ruta
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                ) : (
                                  prestamos.map((prestamo) => (
                                    <TableRow key={prestamo.id_prestamo} hover>
                                      <TableCell>
                                        <Box>
                                          <Typography variant="body1" fontWeight={500}>
                                            {prestamo.cliente_nombre}
                                          </Typography>
                                          <Typography variant="body2" color="text.secondary">
                                            {prestamo.cliente_identificacion}
                                          </Typography>
                                        </Box>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant="body1" fontWeight={500}>
                                          {prestamo.loan_id}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant="body1" fontWeight={500}>
                                          ${formatNumberWithCommas(prestamo.monto)}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <EstadoChip estado={prestamo.prestamo_estado} />
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant="body2" color="text.secondary">
                                          Sin visitas registradas
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  ))
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}

                        {tabValue === "Historial" && (
                          <Box sx={{ mt: 2 }}>
                            {visitas.length === 0 ? (
                              <Alert severity="info">
                                No hay visitas registradas para esta ruta
                              </Alert>
                            ) : (
                              <List>
                                {visitas.map((visita, index) => (
                                  <ListItem key={index} divider>
                                    <ListItemAvatar>
                                      <Avatar sx={{ bgcolor: visita.resultado === 'exitoso' ? 'success.main' : 'warning.main' }}>
                                        {visita.resultado === 'exitoso' ? <CheckCircle /> : <Schedule />}
                                      </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                          <Typography variant="body1" fontWeight={500}>
                                            Visita a {visita.cliente_nombre}
                                          </Typography>
                                          <ResultadoChip resultado={visita.resultado} />
                                        </Box>
                                      }
                                      secondary={
                                        <Box>
                                          <Typography variant="body2" color="text.secondary">
                                            {new Date(visita.fecha_visita).toLocaleString()}
                                          </Typography>
                                          {visita.monto_cobrado > 0 && (
                                            <Typography variant="body2" color="success.main" fontWeight={500}>
                                              Cobrado: ${formatNumberWithCommas(visita.monto_cobrado)}
                                            </Typography>
                                          )}
                                          {visita.notas && (
                                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                              {visita.notas}
                                            </Typography>
                                          )}
                                        </Box>
                                      }
                                    />
                                  </ListItem>
                                ))}
                              </List>
                            )}
                          </Box>
                        )}

                        {tabValue === "Rendimiento" && (
                          <Grid container spacing={3} sx={{ mt: 2 }}>
                            <Grid item size={{ xs: 12, md: 6 }}>
                              <Card variant="outlined" sx={{ p: 2 }}>
                                <CardContent>
                                  <Typography variant="h6" fontWeight={600} mb={2}>
                                    Métricas de Rendimiento
                                  </Typography>
                                  <Box display="flex" flexDirection="column" gap={2}>
                                    <Box display="flex" justifyContent="space-between">
                                      <Typography variant="body2" color="text.secondary">Total Visitas</Typography>
                                      <Typography variant="body1" fontWeight={500}>{performance.total_visitas || 0}</Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between">
                                      <Typography variant="body2" color="text.secondary">Visitas Exitosas</Typography>
                                      <Typography variant="body1" fontWeight={500} color="success.main">
                                        {performance.visitas_exitosas || 0}
                                      </Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between">
                                      <Typography variant="body2" color="text.secondary">Tasa de Éxito</Typography>
                                      <Typography variant="body1" fontWeight={500} color="primary.main">
                                        {performance.tasa_exito || 0}%
                                      </Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between">
                                      <Typography variant="body2" color="text.secondary">Monto Cobrado</Typography>
                                      <Typography variant="body1" fontWeight={500} color="success.main">
                                        ${formatNumberWithCommas(performance.monto_cobrado || 0)}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </CardContent>
                              </Card>
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                              <Card variant="outlined" sx={{ p: 2 }}>
                                <CardContent>
                                  <Typography variant="h6" fontWeight={600} mb={2}>
                                    Resumen de Actividad
                                  </Typography>
                                  <Box display="flex" flexDirection="column" gap={2}>
                                    <Box display="flex" justifyContent="space-between">
                                      <Typography variant="body2" color="text.secondary">Préstamos Asignados</Typography>
                                      <Typography variant="body1" fontWeight={500}>{prestamos.length}</Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between">
                                      <Typography variant="body2" color="text.secondary">Última Actividad</Typography>
                                      <Typography variant="body1" fontWeight={500}>
                                        {ruta.updated_at ? new Date(ruta.updated_at).toLocaleDateString() : 'Sin actividad'}
                                      </Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between">
                                      <Typography variant="body2" color="text.secondary">Fecha de Creación</Typography>
                                      <Typography variant="body1" fontWeight={500}>
                                        {ruta.created_at ? new Date(ruta.created_at).toLocaleDateString() : 'N/A'}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </CardContent>
                              </Card>
                            </Grid>
                          </Grid>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Container>
            </Stack>
          </Box>
        </Box>
              {/* Dialogs */}
      <AsignarPrestamosDialog
        open={openAsignarPrestamos}
        onClose={() => setOpenAsignarPrestamos(false)}
        onConfirm={handleRefresh}
        rutaId={id}
      />

      <AsignarCobradorDialog
        open={openAsignarCobrador}
        onClose={() => setOpenAsignarCobrador(false)}
        onConfirm={handleRefresh}
        rutaId={id}
      />

      <CrearRutaDialog
        open={openEditRuta}
        onClose={() => setOpenEditRuta(false)}
        onConfirm={handleRefresh}
        ruta={ruta}
        isEdit={true}
      />

      </AppTheme>

    </Box>
  );
}